<template>
  <div class="site-footer-component">
    <mini-divider />
    <div class="contact">
      <div class="name">Cannabis Political Economy Symposium</div>
      <div class="address">20 F Street - 7th Floor</div>
      <div class="address">Washington, DC 20001</div>
      <div class="address">Tel: 202-507-6212</div>
      <div class="address">Tel: 202-507-6101</div>
      <div class="address">info@cpesymposium.com</div>
    </div>
    <social-links size="big" class="social"/>
    <mini-divider />
  </div>
</template>
<script>
  import SocialLinks from '@/components/SocialLinks.vue'
  import MiniDivider from '@/components/MiniDivider.vue'

  export default {
    name: 'site-footer-component',
    components: { SocialLinks, MiniDivider },
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    },
  }
</script>
<style scoped lang="scss">
  .site-footer-component {
    text-align: center;
    padding-bottom: 20px;
  }
  .contact {
    padding-top: 20px;
    color: $color-7;
  }
  .social {
    margin: 20px 0;
  }
</style>